// Vue Core APIs
import { createApp, defineAsyncComponent, type Plugin } from 'vue'

// Third-party Libraries
import { createPinia } from 'pinia'
import { Form, Field, ErrorMessage } from 'vee-validate'
import VueLazyload from 'vue-lazyload'
// import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
// import { QuillEditor } from '@vueup/vue-quill'
import { createVCodeBlock } from '@wdns/vue-code-block'
import Toast from 'vue3-toastify'
import JsonViewer from 'vue3-json-viewer'


// Styles
import './index.css'
// import '@vueup/vue-quill/dist/vue-quill.snow.css'
import 'vue3-toastify/dist/index.css'

// Local Imports
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { api, wireAuthRedirect } from '@/plugins/axios'

const VCodeBlock = createVCodeBlock({
  // options
})

// Create App Instance
const app = createApp(App)

// Wire Auth Redirect
wireAuthRedirect(router)

// Global Properties Setup
app.config.globalProperties.$api = api
declare module 'vue' {
  interface ComponentCustomProperties {
    $api: typeof api
  }
}

// Register Plugins and Components
app
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(VCodeBlock as Plugin)
  .use(VueLazyload, {
    preLoad: 1.3,
    error: '/panel/icon/error-img.svg',
    loading: '/panel/img/loading.gif',
    attempt: 1,
  })
  .use(JsonViewer)
  .use(Toast, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'light',
  })

  .component('BaseForm', Form)
  .component('BaseField', Field)
  .component('ErrorMessage', ErrorMessage)
  .component(
    'QuillEditor',
    defineAsyncComponent(async () => {
      await import('@vueup/vue-quill/dist/vue-quill.snow.css')
      const { QuillEditor } = await import('@vueup/vue-quill')
      return QuillEditor
    }),
  )
  .mount('#app')
